var render = function render(){var _vm=this,_c=_vm._self._c;return _c('answers',{ref:"answers",attrs:{"code_question_group":"GQ01","danger_code":"MCAL22","disable_answers":_vm.disableAnswers}})
}
var staticRenderFns = []

export { render, staticRenderFns }